
import { parseJson, oz } from '@weft/utils';

//TODO: change to general sync status and also use it in contract
export const SYNC_STATUSES = Object.freeze({
  None: 'None',
  Synced: 'Synced',
  Failed: 'Failed',
});

export const SyncStatusSchema = oz.nativeEnum(SYNC_STATUSES).openapi('SyncStatus');
export const SyncStatusesSchema = oz.string()
  .transform(s => parseJson<SyncStatus[]>(s))
  .pipe(SyncStatusSchema.array().optional()).optional();
export type SyncStatus = oz.infer<typeof SyncStatusSchema>;